import { faPaperPlane } from "@fortawesome/free-solid-svg-icons";
import { useUserInfor } from "../../../../../../../Context/User";
import {
    AtualizarConfigGeralController,
    ListaFormularioPorModuloController,
    VincularFormularioModuloController,
} from "../../../../../../../Controllers/Geral/GestaoDeCadastros/ConfigGeral/ConfigGeralController";
import UnForm from "../../../../../../Form";
import useAsyncCallback from "../../../../../../../hooks/useAsyncCallback";
import { ListarEtapasPorTipoCasoController } from "../../../../../../../Controllers/Geral/Etapas/EtapasControllers";
import Swal from "sweetalert2";
import { IConfigGeral_Vistoria } from "../../../../../../../Interfaces/Geral/GestaoDeCadastro/ConfigGeral/ConfigGeralInterface";
import { IConfigGeralModulos } from "../../../../../../../Interfaces/Geral/ConfigGeral/ConfigGeral";
import useAsyncEffect from "../../../../../../../hooks/useAsyncEffect";
import { GetConfigModuloController } from "../../../../../../../Controllers/Geral/ConfigGeral/ConfigGeralController";
import { ListarFormulariosController } from "../../../../../../../Controllers/Geral/Formularios/FormulariosControllers";
import { ACESSOS } from "../../../../../../../Routes/Acessos";
import { ListarEmailContaController } from "../../../../../../../Controllers/Geral/GestaoDeCadastros/EmailConta/EmailContaController";

interface IVistoriaEntregaChavesConfig {
    lstConfigModulo: IConfigGeralModulos[] | undefined;
    AtualizarConfigModulo: (requestBody: IConfigGeralModulos) => Promise<any>;
    ListConfigModulo: (...args: any[]) => Promise<IConfigGeralModulos[]>;
}

export default function VistoriaEntregaChavesConfig(
    props: IVistoriaEntregaChavesConfig
) {
    const { Config, updateConfig } = useUserInfor();
    const config = Config.ConfigVistoriaDTO;

    // const [emailDestinatario, setEmailDestinatario] = useState<
    //     Array<string> | undefined
    // >([]);
    // const customStyles = {
    //     control: (base: any) => ({
    //         ...base,
    //         boxShadow: "none",
    //     }),
    // };

    // const { value: lstContatos, ...ListarContatos } = useAsyncEffect(
    //     () => ListarContatosController(props.ID_CONTA, props.ID_CASO),
    //     [props.ID_CONTA]
    // );

    // const options = lstContatos?.map((contato) => ({
    //     label: `${contato.DS_EMAIL ? contato.DS_NOME : ""} ${
    //         contato.DS_EMAIL ? `<${contato.DS_EMAIL}>` : ""
    //     }`,
    //     value: contato.DS_EMAIL ?? "",
    // }));

    const idModuloVistoria = props.lstConfigModulo?.find(
        (lst) => lst.ID_MODULO === 10
    );

    const { value: getConfigModulo } = useAsyncEffect(async () => {
        if (idModuloVistoria) {
            return GetConfigModuloController(idModuloVistoria.ID_MODULO);
        }
    }, [idModuloVistoria]);

    const { value: lstFormularioPorModulo, execute: ListaFormularioPorModulo } =
        useAsyncEffect(
            () =>
                ListaFormularioPorModuloController(
                    ACESSOS.ENTREGA_DE_CHAVES.ID_MODULO
                ),
            []
        );

    const {
        execute: VincularFormularioModulo,
        loading: VincularFormularioModuloLoading,
    } = useAsyncCallback(VincularFormularioModuloController);

    function update() {
        AtualizarConfigGeralController({
            ...Config,
            ConfigVistoriaDTO: {
                ...config,
            },
            FL_ENVIO_HORARIOS_DISPONIVEIS: Config.FL_ENVIO_HORARIOS_DISPONIVEIS,
        }).then(() => {
            updateConfig();
        });
    }

    const { execute: listarEtapasPorTipoCaso } = useAsyncCallback(
        () => ListarEtapasPorTipoCasoController(10),
        []
    );

    const handleSubmit = (formValue: IConfigGeral_Vistoria) => {
        config.ID_RETORNO_ETAPA_CASO =
            formValue.ID_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO
                ? formValue.ID_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO
                : 0;
        if (formValue.NR_AGENDAMENTOS_HORARIO > 0) {
            Config.ConfigVistoriaDTO.NR_AGENDAMENTOS_HORARIO =
                formValue.NR_AGENDAMENTOS_HORARIO;
            update();
        } else {
            Swal.fire({
                title: `Somente números positivos são permitidos!`,
                icon: "info",
                confirmButtonText: "<i class='la la-check'></i> Ok!",
                customClass: {
                    confirmButton: "btn btn-outline-success",
                },
                timer: 5000,
            });
        }
    };

    // const handleSubmit = (formValue: any) => {
    //     config.ID_RETORNO_ETAPA_CASO =
    //         formValue.ID_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO
    //             ? formValue.ID_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO
    //             : 0;
    //     update();
    // };

    const handleEmailSubmit = (formValue: any) => {
        config.DS_EMAIL_ENVIO_VISTORIA = formValue.ID_REMETENTE
            ? formValue.ID_REMETENTE
            : null;
        update();
    };

    const handleFormularioSubmit = (formValue: any) => {
        if (formValue.ID_FORMULARIO) {
            console.log("Formulário selecionado", formValue.ID_FORMULARIO);
            VincularFormularioModulo(
                ACESSOS.ENTREGA_DE_CHAVES.ID_MODULO,
                formValue.ID_FORMULARIO
            ).then(() => {
                ListaFormularioPorModulo();
                update();
            });
        }
    };
    return (
        <>
            <div className="col-12 mb-4">
                <h4>Abrir novo atendimento</h4>
                <div className="d-flex flex-column">
                    <label className="col-12 col-form-label px-0">
                        Abrir novo atendimento ao receber resposta do cliente no
                        email de finalização do caso.
                    </label>
                    <div className="col-6">
                        <span className="switch switch-outline switch-icon switch-success">
                            <label>
                                <input
                                    type="checkbox"
                                    checked={
                                        getConfigModulo?.ConfigModuloCampo
                                            .FL_CRIAR_ATEND_RESPOSTA_EMAIL
                                    }
                                    onChange={(e) => {
                                        props
                                            .AtualizarConfigModulo({
                                                ConfigModuloCampo: {
                                                    FL_CRIAR_ATEND_RESPOSTA_EMAIL:
                                                        Boolean(
                                                            e.target.checked
                                                        ),
                                                },
                                                ID_MODULO:
                                                    getConfigModulo?.ID_MODULO ??
                                                    0,
                                            })
                                            .then(() => {
                                                props.ListConfigModulo();
                                                updateConfig();
                                            });
                                    }}
                                    name="select"
                                />
                                <span></span>
                            </label>
                        </span>
                    </div>
                </div>
                <div className="d-flex flex-column">
                    <label className="col-12 col-form-label px-0">
                        Enviar e-mail ao cliente notificando abertura de atendimento.
                    </label>
                    <div className="col-6">
                        <span className="switch switch-outline switch-icon switch-success">
                            <label>
                                <input
                                    type="checkbox"
                                    checked={
                                        config?.FL_ENVIAR_EMAIL_ABERTURA_ATENDIMENTO_VISTORIA
                                    }
                                    onChange={() => {
                                        config.FL_ENVIAR_EMAIL_ABERTURA_ATENDIMENTO_VISTORIA =
                                            !config.FL_ENVIAR_EMAIL_ABERTURA_ATENDIMENTO_VISTORIA;
                                        update();
                                    }}
                                    name="select"
                                />
                                <span></span>
                            </label>
                        </span>
                    </div>
                </div>
            </div>

            <div className="col-12 mb-4">
                <h4>Produto por Grupo</h4>
                <div className="d-flex flex-column">
                    <label className="col-12 col-form-label px-0">
                        Permitir Selecionar o Produto de acordo com o Grupo?
                    </label>
                    <div className="col-12">
                        <span className="switch switch-outline switch-icon switch-success">
                            <label>
                                <input
                                    type="checkbox"
                                    checked={
                                        config?.FL_SEGURANCA_GRUPO_PRODUTO_VISTORIA
                                    }
                                    onChange={() => {
                                        config.FL_SEGURANCA_GRUPO_PRODUTO_VISTORIA =
                                            !config.FL_SEGURANCA_GRUPO_PRODUTO_VISTORIA;
                                        update();
                                    }}
                                    name="select"
                                />
                                <span></span>
                            </label>
                        </span>
                    </div>
                </div>
                <div className="d-flex flex-column mb-4">
                    <label className="col-12 col-form-label px-0">
                        Envio de link com horários disponíveis.
                    </label>
                    <div className="col-12">
                        <span className="switch switch-outline switch-icon switch-success">
                            <label>
                                <input
                                    type="checkbox"
                                    checked={
                                        Config?.FL_ENVIO_HORARIOS_DISPONIVEIS
                                    }
                                    onChange={() => {
                                        Config.FL_ENVIO_HORARIOS_DISPONIVEIS =
                                            !Config.FL_ENVIO_HORARIOS_DISPONIVEIS;
                                        update();
                                    }}
                                    name="select"
                                />
                                <span></span>
                            </label>
                        </span>
                    </div>
                </div>

                <h4>Agendamentos cadastrados</h4>
                <div className="d-flex flex-column mb-4">
                    <label className="col-12 col-form-label px-0">
                        Agendamento deverá listar apenas as disponibilidades
                        previamente cadastradas
                    </label>
                    <div className="col-12">
                        <span className="switch switch-outline switch-icon switch-success">
                            <label>
                                <input
                                    type="checkbox"
                                    checked={
                                        config.FL_AGENDAMENTO_HORARIOS_CADASTRADOS_VISTORIA
                                    }
                                    onChange={() => {
                                        config.FL_AGENDAMENTO_HORARIOS_CADASTRADOS_VISTORIA =
                                            !config.FL_AGENDAMENTO_HORARIOS_CADASTRADOS_VISTORIA;
                                        update();
                                    }}
                                    name="select"
                                />
                                <span></span>
                            </label>
                        </span>
                    </div>
                </div>

                <h4>Preenchimento de nome no Formulário</h4>
                <div className="d-flex flex-column mb-4">
                    <label className="col-12 col-form-label px-0">
                        Permitir apenas nomes dos contatos vinculados ao proponente
                    </label>
                    <div className="col-12">
                        <span className="switch switch-outline switch-icon switch-success">
                            <label>
                                <input
                                    type="checkbox"
                                    checked={
                                        config.FL_NOME_ASSINANTE_PRE_DEFINIDO_FORMULARIO_VIST
                                    }
                                    onChange={() => {
                                        config.FL_NOME_ASSINANTE_PRE_DEFINIDO_FORMULARIO_VIST =
                                            !config.FL_NOME_ASSINANTE_PRE_DEFINIDO_FORMULARIO_VIST;
                                        update();
                                    }}
                                    name="select"
                                />
                                <span></span>
                            </label>
                        </span>
                    </div>
                </div>

                {/*   <div className="d-flex flex-column mb-4">
                    <label className="col-12 col-form-label px-0">
                        texto aq
                    </label>
                   <div className="col-6">
                        <label>Email Destinatário:</label>
                        <CreatableSelect
                            isMulti
                            isClearable
                            isSearchable
                            onChange={(e) => {
                                setEmailDestinatario(
                                    e.map((value) => value?.value)
                                );
                            }}
                            formatCreateLabel={(value) =>
                                `Clique para selecionar: ${value}`
                            }
                            styles={customStyles}
                            placeholder={"Digite o email"}
                            options={{
                                
                            }}
                            // defaultValue={
                            //     lstContatos?.filter(
                            //         (c) => c.FL_PROPONENTE === true
                            //     )[0]?.DS_EMAIL !== ""
                            //         ? defaultValue()
                            //         : undefined
                            // }
                            className="Select-menu-outer"
                        />
                    </div> 
                    <div className="col-6 ml-2">
                        <button className="btn btn-success">Salvar</button>
                    </div>
                </div>*/}

                <h4>Reiniciar Caso e Agendamentos</h4>
            </div>

            <UnForm handleSubmit={handleSubmit}>
                <div className="d-flex align-items-center">
                    <>
                        <div className="col-6">
                            <UnForm.LazySelect
                                getDS={(je) =>
                                    je.DS_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO
                                }
                                getKeyValue={(je) =>
                                    je.ID_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO
                                }
                                controller={listarEtapasPorTipoCaso}
                                name="ID_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO"
                                label="Insira uma Etapa Categoria Atendimento"
                                defaultValue={config.ID_RETORNO_ETAPA_CASO}
                            >
                                <option></option>
                            </UnForm.LazySelect>
                        </div>
                        <div className="col-6">
                            <label>
                                Quantidade de clientes que podem realizar
                                vistoria no mesmo horário
                            </label>
                            <UnForm.Input
                                name="NR_AGENDAMENTOS_HORARIO"
                                type={"number"}
                                defaultValue={
                                    Config.ConfigVistoriaDTO
                                        .NR_AGENDAMENTOS_HORARIO
                                }
                                registerOptions={{
                                    required: "Insira uma quantidade",
                                }}
                            />
                        </div>
                    </>
                </div>
                <div className="col-12">
                    <label></label>
                    <UnForm.SubmitButton
                        color="success"
                        icon={faPaperPlane}
                        loadingSize="sm"
                    >
                        Atualizar
                    </UnForm.SubmitButton>
                </div>
            </UnForm>
            <UnForm handleSubmit={handleEmailSubmit}>
                <div className="d-flex flex-column col-12 col-md-6">
                    <h4 className="pt-2">Disparo de email agendamento</h4>{" "}
                    <label className="col-12 col-form-label px-0">
                        Selecione o email de disparo para agendamento
                    </label>
                    <UnForm.LazySelect
                        name="ID_REMETENTE"
                        controller={ListarEmailContaController}
                        getDS={(ds) => ds.DS_USERNAME}
                        getKeyValue={(key) => key.DS_USERNAME}
                        defaultValue={config.DS_EMAIL_ENVIO_VISTORIA ?? ""}
                        placeholder={"Digite o email"}
                        filter={(u) => u.FL_VALIDADO}
                    >
                        <option value={""}></option>
                    </UnForm.LazySelect>
                </div>
                <div className="d-flex align-items-center">
                    <div>
                        <label></label>
                        <UnForm.SubmitButton
                            color="success"
                            icon={faPaperPlane}
                            loadingSize="sm"
                        >
                            Atualizar Email
                        </UnForm.SubmitButton>
                    </div>
                </div>
            </UnForm>

            <div className="col-12 col-md-6 mb-4 mt-4">
                <h4>Selecionar formulário</h4>
                <div className="d-flex flex-column">
                    <label className="col-12 col-form-label px-0">
                        Deseja selecionar um formulário para o atendimento?
                    </label>
                    <div className="col-12">
                        <span className="switch switch-outline switch-icon switch-success">
                            <label>
                                <input
                                    type="checkbox"
                                    checked={
                                        Config.FL_ESCOLHER_FORMULARIO_VISTORIA
                                    }
                                    onChange={() => {
                                        Config.FL_ESCOLHER_FORMULARIO_VISTORIA =
                                            !Config.FL_ESCOLHER_FORMULARIO_VISTORIA;
                                        update();
                                    }}
                                    name="select"
                                />
                                <span></span>
                            </label>
                        </span>
                    </div>
                </div>
            </div>

            {Config.FL_ESCOLHER_FORMULARIO_VISTORIA && (
                <UnForm handleSubmit={handleFormularioSubmit}>
                    <div className="col-12 col-md-6">
                        <UnForm.LazySelect
                            label="Selecione um formulário"
                            name="ID_FORMULARIO"
                            controller={ListarFormulariosController}
                            getDS={(ds) => ds.DS_FORMULARIO}
                            getKeyValue={(key) => key.ID_FORMULARIO}
                            registerOptions={{
                                required: "Selecione um formulário",
                            }}
                            defaultValue={lstFormularioPorModulo?.ID_FORMULARIO}
                        >
                            <option></option>
                        </UnForm.LazySelect>
                    </div>
                    <div className="d-flex align-items-center">
                        <div>
                            <label></label>
                            <UnForm.SubmitButton
                                color="success"
                                icon={faPaperPlane}
                                loadingSize="sm"
                                loading={VincularFormularioModuloLoading}
                                disabled={VincularFormularioModuloLoading}
                            >
                                Escolher formulário
                            </UnForm.SubmitButton>
                        </div>
                    </div>
                </UnForm>
            )}
        </>
    );
}
